import React from 'react';
import FeaturedImage from './FeaturedImage';
import Slider from "react-slick";

const PostGallery = (props) => {
    const {
        post,
        gallery,
        imageSize
    } = props;

    const sliderSettings = {
        dots: true,
    };

    let featuredImageTag;
    
    if (post.hasOwnProperty('_embedded') && post._embedded.hasOwnProperty('wp:featuredmedia')) {
        featuredImageTag = <figure className="cpt-post-gallery-item">
            <FeaturedImage
                imageSize={imageSize}
                image={post._embedded['wp:featuredmedia']}
                srcset={post.featured_image_srcset}
            ></FeaturedImage>
        </figure>
    }

    let galleryTag =
        <Slider {...sliderSettings}>
            {featuredImageTag}
            {
                gallery.map((item, index) => {
                    return (
                        <figure
                            className="cpt-post-gallery-item"
                            key={index}
                            dangerouslySetInnerHTML={{ __html: item }}
                        >
                        </figure>
                    );
                })
            }

        </Slider>


    return galleryTag;
}

export default PostGallery;